import { Box, Grid2 as Grid, Typography } from '@mui/material';
import PerformanceCard from './PerformanceCard';
import PerformanceCardSkeleton from './PerformanceCardSkeleton';
import { useTranslation } from 'react-i18next';

export default function DetailsGrid({ detailsData, isLoading }) {
  const { t } = useTranslation(['description']);

  if (isLoading) {
    return (
      <Grid container spacing={2} size={12} columns={10}>
        {Array.from({ length: detailsData.length || 5 }).map((_, index) => (
          <Grid key={index} size={{ xs: 10, lg: 2 }}>
            <PerformanceCardSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h6" component="h2">
          {t('description:payments.dashboard.details_values')}
        </Typography>
      </Grid>

      <Grid
        size={{ xs: 12, lg: 'auto' }}
        sx={{ display: { xs: 'block', lg: 'none' }, width: '100%' }}
      >
        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 2,
            pb: 1,
            '&::-webkit-scrollbar': {
              height: '0px',
            },
          }}
        >
          {detailsData.map((details, index) => (
            <Box
              key={index}
              sx={{
                flexShrink: 0,
                width: '85%',
              }}
            >
              <PerformanceCard
                avatar={details.avatar}
                title={details.title}
                icon={details.icon}
                value={details.value}
                valueMuted={details.valueMuted}
                footerTitle={details.footerTitle}
                footerDescription={details.footerDescription}
              />
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid
        container
        spacing={2}
        size={12}
        columns={10}
        sx={{ display: { xs: 'none', lg: 'flex' } }}
      >
        {detailsData.map((details, index) => (
          <Grid key={index} size={{ lg: 2 }}>
            <PerformanceCard
              avatar={details.avatar}
              title={details.title}
              icon={details.icon}
              value={details.value}
              valueMuted={details.valueMuted}
              footerTitle={details.footerTitle}
              footerDescription={details.footerDescription}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
